import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '@/components/base/Logo';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navBg =
    scrolled || !isHome
      ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
      : 'bg-transparent';

  const textColor = scrolled || !isHome ? 'text-foreground-900' : 'text-background-50';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
      <div className="flex items-center justify-between px-6 md:px-10 h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2.5">
          <Logo className="w-8 h-8 object-contain" />
          <span className={`font-semibold text-base tracking-tight ${textColor}`}>
            Central Check
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <a
            href="#recursos"
            className={`text-sm font-medium hover:opacity-80 transition-opacity ${textColor}`}
          >
            Recursos
          </a>
          <a
            href="#planos"
            className={`text-sm font-medium hover:opacity-80 transition-opacity ${textColor}`}
          >
            Planos
          </a>
          <a
            href="#"
            className={`text-sm font-medium hover:opacity-80 transition-opacity ${textColor}`}
          >
            Contratar
          </a>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/login"
            className={`text-sm font-medium px-4 py-2 rounded-md border transition-all ${
              scrolled || !isHome
                ? 'border-foreground-200 text-foreground-800 hover:bg-foreground-50'
                : 'border-background-400/50 text-background-50 hover:bg-background-50/10'
            }`}
          >
            Acessar sistema
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl ${textColor}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-6 py-4 flex flex-col gap-3">
          <a
            href="#recursos"
            className="text-sm font-medium text-foreground-800 py-2"
            onClick={() => setMobileOpen(false)}
          >
            Recursos
          </a>
          <a
            href="#planos"
            className="text-sm font-medium text-foreground-800 py-2"
            onClick={() => setMobileOpen(false)}
          >
            Planos
          </a>
          <a
            href="#"
            className="text-sm font-medium text-foreground-800 py-2"
            onClick={() => setMobileOpen(false)}
          >
            Contratar
          </a>
          <Link
            to="/login"
            className="text-sm font-medium text-primary-600 py-2"
            onClick={() => setMobileOpen(false)}
          >
            Acessar sistema
          </Link>
        </div>
      )}
    </nav>
  );
}
